import { getMeetingListFromAuthUserIdApi } from 'api/meeting';
import MeetingDataTable from 'app/components/DataTable/meeting/MeetingDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setPageType } from 'stores/meeting';

// tam okuma listesi 368,371
const ListMeeting = () => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [meetingList, setMeetingList] = useState([]);
    const [total, setTotal] = useState(0);
    const [tableQuery, setTableQuery] = useState(null);
    const { pageType } = useParams();

    useEffect(() => {
        dispatch(setPageType(pageType));
    }, [pageType]);

    useEffect(() => {
        const getAPI = async () => {
            if (!tableQuery) return;

            setLoading(true);
            try {
                const params = {
                    page: tableQuery.page,
                    limit: tableQuery.limit,
                    q: tableQuery.q,
                    sortBy: tableQuery.sortBy,
                    sortOrder: tableQuery.sortOrder,
                    pageType,
                    ...tableQuery.filters,
                };

                const res = await getMeetingListFromAuthUserIdApi("read", params);
                setMeetingList(res.data?.items || []);
                setTotal(res.data?.total || 0);

            } catch (error) {
                console.error("API Hatası: ", error);
            } finally {
                setLoading(false);
            }
        };

        getAPI();
    }, [pageType, tableQuery]);

    const columnData = [
        { id: 'inst', align: 'left', disablePadding: false, label: "Kurum" },
        { id: 'unit', align: 'left', disablePadding: true, label: "Kurul/Kol/Komisyon" },
        { id: 'meetingNo', align: 'left', disablePadding: false, label: "Toplantı No" },
        { id: 'pdate', align: 'left', disablePadding: true, label: "Tarih" },
        { id: 'adminUserId', align: 'center', disablePadding: false, label: "Toplantı Yöneticisi" },
        { id: 'decisionCount', align: 'left', disablePadding: true, label: "Karar Sayısı" },
        { id: 'userParticipantList', align: 'center', disablePadding: true, label: "Üyeler / Katılımcılar" },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler" }
    ];

    return (
        <React.Fragment>
            <>
                <LoadingPopUp open={loading} />
                <MeetingDataTable
                    key={pageType || 'read'}
                    column={columnData}
                    pageTitle="Toplantı Listesi (Okuma)"
                    mainData={meetingList}
                    listTotal={total}
                    onQueryChange={setTableQuery}
                />
            </>
        </React.Fragment>
    );
};

export default ListMeeting;
